module.exports = __webpack_public_path__ + "static/img/main_mainpage_icon03_b.691416d8.svg";